import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// ความหมายของ statusflow จาก API: 105 = Successful, 201 = Reject, 211 = EditReject
const REJECT_STATUSES = ['201', '211'];

const STEP_STYLES = {
    done: { label: 'Completed', bg: '#2e7d32', border: '#2e7d32', color: '#fff' },
    current: { label: 'In progress', bg: '#fff8e1', border: '#f9a825', color: '#e65100' },
    rejected: { label: 'Rejected', bg: '#e53935', border: '#e53935', color: '#fff' },
    pending: { label: 'Waiting', bg: '#fff', border: '#cfd8dc', color: '#90a4ae' },
};

function getStepState(step, current, { statusflow, activeapproved }) {
    if (String(statusflow) === '105') return 'done';
    if (step < current) return 'done';
    if (step > current) return 'pending';
    if (REJECT_STATUSES.includes(String(statusflow))) return 'rejected';
    return activeapproved == 1 ? 'done' : 'current';
}

// แถบแสดงความคืบหน้าของ flow: วงกลมแต่ละขั้น + เส้นเชื่อม + ตัวเลขขั้นปัจจุบัน/ทั้งหมด
function FlowSteps({ stateflow, endstateflow, statusflow, activeapproved }) {
    const total = parseInt(endstateflow, 10) || 0;
    const current = parseInt(stateflow, 10) || 0;
    if (total <= 0) return null;

    const states = Array.from({ length: total }, (_, i) => getStepState(i + 1, current, { statusflow, activeapproved }));
    const doneCount = states.filter((s) => s === 'done').length;
    const isRejected = states.includes('rejected');

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, height: '100%' }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                {states.map((state, i) => {
                    const style = STEP_STYLES[state];
                    return (
                        <React.Fragment key={i}>
                            {i > 0 &&
                                <Box sx={{ width: 10, height: 2, borderRadius: 1, bgcolor: state === 'done' ? '#2e7d32' : '#e0e6ea' }} />}
                            <Tooltip title={`Step ${i + 1} · ${style.label}`} arrow>
                                <Box sx={{
                                    width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    bgcolor: style.bg, border: `2px solid ${style.border}`, color: style.color,
                                    fontSize: 10.5, fontWeight: 700, boxSizing: 'border-box',
                                    boxShadow: state === 'current' ? '0 0 0 3px rgba(249, 168, 37, 0.22)' : 'none',
                                }}>
                                    {state === 'done' && <CheckRoundedIcon sx={{ fontSize: 14 }} />}
                                    {state === 'rejected' && <CloseRoundedIcon sx={{ fontSize: 14 }} />}
                                    {(state === 'current' || state === 'pending') && i + 1}
                                </Box>
                            </Tooltip>
                        </React.Fragment>
                    );
                })}
            </Box>
            <Box component="span" sx={{ fontSize: 12, fontWeight: 600, color: isRejected ? '#e53935' : doneCount === total ? '#2e7d32' : '#78909c', whiteSpace: 'nowrap' }}>
                {doneCount}/{total}
            </Box>
        </Box>
    );
}

export default FlowSteps;
